import type { LucideIcon } from 'lucide-react';
import { TileIcon, TileLabel, homeTileButtonClass } from '@features/dashboard/TileIcon';
import { PanicSosBadge } from '@features/panic/PanicSosBadge';

/**
 * One entry of the home Quick Links set, flattened from every source that feeds
 * the rail — tenant tiles, `more_categories` groups and the permission-gated
 * admin shortcuts — so the rail and the "View all" sheet render one list.
 */
export interface QuickLinkItem {
  /** Stable id; also the key for most-recently-used ordering. */
  id: string;
  label: string;
  imageUrl?: string;
  /** Lucide fallback when the link has no module image. */
  fallbackIcon?: LucideIcon;
  isPanic?: boolean;
  onSelect: () => void;
}

/** Quick-link tile chrome, shared by the home rail and the "View all" sheet. */
export function QuickLinkTile({
  link,
  onSelect,
}: {
  link: QuickLinkItem;
  onSelect: () => void;
}): JSX.Element {
  return (
    <button type="button" onClick={onSelect} className={homeTileButtonClass}>
      {link.isPanic ? (
        <span className="flex h-full w-full items-center justify-center">
          <PanicSosBadge className="h-12 w-12 text-sm" />
        </span>
      ) : (
        <>
          <TileIcon imageUrl={link.imageUrl} label={link.label} fallbackIcon={link.fallbackIcon} />
          <TileLabel label={link.label} />
        </>
      )}
    </button>
  );
}
